import React from 'react'

import Header from '../../../components/Arabic/Header/Header'
import Slider from '../../../components/Arabic/Slider/Slider'
import OurActivities from '../../../components/Arabic/OurActivities/OurActivities'
import OurProducts from '../../../components/Arabic/OurProducts/OurProducts'
import AboutUs from '../../../components/Arabic/AboutUs/AboutUs'
import Promotion from '../../../components/Arabic/Promotion/Promotion'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import Footer from '../../../components/Arabic/Footer/Footer'

export default function Home() {
  return (
    <div>
      <Header page={'home'} />
      <Slider />
      <OurActivities />
      <OurProducts />
      <AboutUs />
      <Promotion />
      <LogoPartner />
      <Footer />
    </div>
  )
}
